import qs from 'query-string';

import { getCsrfToken } from './csrf';

import { browserTimeOfDay } from '../stimulus/models/helpers';

export async function refreshLeftNav(active: string) {
  const init: RequestInit = {
    headers: {
      'X-CSRF-Token': getCsrfToken() || '',
      'X-Requested-With': 'XMLHttpRequest',
      Accept: 'text/html',
    },
    credentials: 'same-origin',
  };
  // eslint-disable-next-line camelcase
  const user_time_of_day = browserTimeOfDay();
  const url = `/app/left_nav?${qs.stringify({ active, user_time_of_day })}`; // eslint-disable-line camelcase

  return (
    fetch(url, init)
      .then(async response => {
        const text = await response.text();
        document.querySelector('[data-js-target="left-nav"]')!.innerHTML = text;
      })
      // eslint-disable-next-line no-console
      .catch(err => console.warn(err))
  );
}
